<template>
  <div>
    <div id="tiny-slider-modal-preview" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="mx-6">
              <div v-html="recomendations" class="center-mode"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="save-supplement-success" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-9" />
      <div class="ml-4 mr-4">
        <div class="font-medium">{{ $t("views.supplements.text9") }}</div>
        <div class="text-gray-600 mt-1"></div>
      </div>
    </div>
    <!-- Marca: nombre de la marca -->
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">{{ $t("views.perfil_marca.text16") }}: {{ brand.name }}</h2>
    </div>
    <div class="grid grid-cols-1 gap-6 mt-5 mb-12">
      <div class="intro-y col-span-12 lg:col-span-6">
        <div class="lang__tabs nav nav-tabs flex-col sm:flex-row text-gray-600 rounded-b-none" role="tablist">
          <a
            v-for="(lang, key) in langs"
            :key="key"
            data-toggle="tab"
            @click="changeLang('lang__' + lang.key)"
            :data-target="'#lang__' + lang.key"
            href="javascript:;"
            class="tooltip w-full sm:w-40 py-4 text-center flex justify-center items-center rounded-t-md"
            :class="activeLang === 'lang__' + lang.key ? 'active' : ''"
            :id="'lang__' + lang.key + '-tab'"
            role="tab"
            :aria-controls="'lang__' + lang.key"
            aria-selected="false"
          >
            {{ $t("components.langs." + lang.key + ".name") }}
          </a>
        </div>
        <div v-for="(lang, key) in langs" :key="key" :class="'post__lang__' + lang.key" class="tab-content">
          <div
            :id="'lang__' + lang.key"
            class="tab-pane"
            :class="activeLang === 'lang__' + lang.key ? 'active' : ''"
            role="tabpanel"
            :aria-labelledby="'lang__' + lang.key + '-tab'"
          >
            <!-- BEGIN: Form Layout -->
            <div class="intro-y box p-5">
              <!-- campo de nombre -->
              <div class="mt-4">
                <div class="w-full">
                  <div class="mt-3">
                    <label for="crud-form-1" class="form-label">{{ $t("views.perfil_marca.text2") }} </label>
                    <div class="input-group">
                      <input
                        id="crud-form-1"
                        type="text"
                        name="chart-tooltip"
                        class="form-control w-full"
                        :placeholder="$t('views.perfil_marca.text2')"
                        v-model="brand.name"
                      />
                    </div>
                    <div v-if="validations.name" class="text-theme-6 mt-2">
                      {{ $t("views.perfil_marca.text17") }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- Pais de origen-->
              <div class="mt-4">
                <label for="crud-form-3" class="form-label">{{ $t("views.perfil_marca.text18") }}</label>
                <div class="input-group">
                  <TomSelect
                    ref="country-lang"
                    class="w-full cursor"
                    v-model="brand.countryBrand"
                    :options="countries"
                    :placeholder="$t('views.food.text22')"
                  >
                    <option :value="lang_key">{{ $t("views.food.text22") }}</option>
                    <option v-for="(country, key) in countries" :key="key" :value="country.lang.toLowerCase()">
                      {{ country.name }}
                    </option>
                  </TomSelect>
                </div>
              </div>
              <!-- campo de sitio web-->
              <div class="mt-4">
                <label for="crud-form-3" class="form-label">{{ $t("views.perfil_marca.text3") }}</label>
                <div class="input-group">
                  <input
                    id="crud-form-1"
                    type="url"
                    name="chart-tooltip"
                    class="form-control w-full"
                    :placeholder="
                      $t('views.supplements.text42') + ': https://www.medicalresearch.com/sources/evidence.pdf'
                    "
                    v-model="brand.url"
                    @blur="validateURLs"
                    @keypress.enter.prevent="validateURLs"
                  />
                </div>
                <div v-if="validations.url" class="text-theme-6 mt-2">
                  {{ $t("views.perfil_marca.text17") }}
                </div>
              </div>
              <!-- campo de historia de la marca-->
              <div class="mt-4">
                <label for="crud-form-3" class="form-label">{{ $t("views.perfil_marca.text4") }}</label>
                <div class="input-group">
                  <textarea
                    id="crud-form-3"
                    type="text"
                    class="form-control"
                    :placeholder="$t('views.supplements.text14')"
                    aria-describedby="input-group-1"
                    rows="6"
                    v-model="lang_inputs[lang_key].history"
                    maxlength="1000"
                  />
                </div>
                <div v-if="validations.history" class="text-theme-6 mt-2">
                  {{ $t("views.perfil_marca.text17") }}
                </div>
              </div>
              <!-- campo de logo de la marca-->
              <div class="mt-4">
                <div class="input-group">
                  <div class="">
                    <label for="crud-form-3" class="form-label mb-5">{{ $t("views.perfil_marca.text5") }}</label>
                    <p style="display: none" class="mb-5">{{ $t("views.perfil_marca.text21") }}</p>
                    <Dropzone
                      v-if="showGallery"
                      class="w-full"
                      ref="gallery"
                      refKey="gallery"
                      v-model="gallery"
                      :options="galleryOptions"
                      :events="{ addedFile: onFileAdd, removedFile: onFileRemove, showMessage: showMessageDropzone }"
                      :existFiles="gallery"
                    />
                  </div>
                </div>
              </div>
              <!-- campo de fecha de fundacion-->
              <div class="mt-3">
                <label for="crud-form-3" class="form-label">{{ $t("views.perfil_marca.text6") }}</label>
                <div class="input-group">
                  <input
                    id="crud-form-1"
                    type="date"
                    name="chart-tooltip"
                    class="form-control w-full"
                    :placeholder="$t('views.perfil_marca.text6')"
                    v-model="brand.fundation"
                    :max="maxDate"
                    @blur="validateFundationDate"
                    @input="validateFundationDate"
                  />
                </div>
                <div v-if="validations.fundation" class="text-theme-6 mt-2">
                  {{ $t("views.perfil_marca.text17") }}
                </div>
              </div>
              <!-- campo de contactos -->
              <div class="mt-5">
                <label for="crud-form-4" class="form-label font-bold">{{ $t("views.perfil_marca.text7") }}</label>
                <div class="grid gap-6">
                  <div
                    class="border-custom-gray-8 border-1 rounded-lg p-4"
                    v-for="(contact, key) in brand.contacts"
                    :key="key"
                  >
                    <!-- Botón para eliminar contacto -->
                    <div class="w-auto pr-2 flex justify-end items-start mt-2">
                      <button
                        v-on:click="removeContact(key)"
                        type="button"
                        class="btn-outline-dark p-0 btn-rounded btn-md remove-item"
                      >
                        <XCircleIcon class="btn-source-icon w-6 h-6" />
                      </button>
                    </div>

                    <div class="input-group gap-5">
                      <!-- Campo nombre -->
                      <div class="w-1/2">
                        <label for="name" class="form-label">{{ $t("views.perfil_marca.text8") }}</label>
                        <input
                          type="text"
                          id="name"
                          v-model="contact.nameCont"
                          class="form-control w-full"
                          :placeholder="$t('views.perfil_marca.text8')"
                        />
                      </div>

                      <!-- Campo cargo -->
                      <div class="w-1/2">
                        <label for="position" class="form-label">{{ $t("views.perfil_marca.text9") }}</label>
                        <input
                          type="text"
                          id="position"
                          v-model="contact.position"
                          class="form-control w-full"
                          :placeholder="$t('views.perfil_marca.text9')"
                        />
                      </div>
                    </div>

                    <!-- Campo email -->
                    <div class="mt-4">
                      <label for="email" class="form-label">{{ $t("views.perfil_marca.text10") }}</label>
                      <input
                        type="email"
                        id="email"
                        v-model="contact.email"
                        class="form-control w-full"
                        :placeholder="$t('views.perfil_marca.text10')"
                      />
                      <div v-if="!isEmailValid(contact.email) && contact.email" class="text-theme-6 mt-2">
                        {{ $t("views.perfil_marca.text10") }}
                      </div>
                    </div>

                    <!-- Campo teléfono con código de área -->
                    <div class="mt-4">
                      <label for="phone" class="form-label">{{ $t("views.perfil_marca.text11") }}</label>
                      <div class="flex">
                        <input
                          type="tel"
                          id="phone"
                          v-model="contact.phone"
                          class="form-control w-3/4"
                          :placeholder="$t('views.perfil_marca.text11')"
                        />
                      </div>
                    </div>

                    <!-- Botón para agregar más contactos -->
                    <div class="mt-4">
                      <button
                        @click="addContact"
                        type="button"
                        class="btn btn-primary"
                        :disabled="!validateContactFields()"
                      >
                        {{ $t("views.perfil_marca.text12") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- campo de POLITICAS DE DISTRIBUCION-->
              <div class="mt-5">
                <label for="crud-form-3" class="form-label">{{ $t("views.perfil_marca.text13") }}</label>
                <div class="input-group">
                  <textarea
                    id="crud-form-3"
                    type="text"
                    class="form-control"
                    :placeholder="$t('views.perfil_marca.text13')"
                    aria-describedby="input-group-1"
                    rows="6"
                    v-model="lang_inputs[lang_key].politic"
                    maxlength="900"
                  />
                </div>
                <div v-if="validations.politic" class="text-theme-6 mt-2">
                  {{ $t("views.perfil_marca.text17") }}
                </div>
              </div>
              <!-- campo de valoraciones de la marca-->
              <div class="mt-5">
                <label for="crud-form-3" class="form-label">{{ $t("views.perfil_marca.text14") }}</label>
                <div class="input-group">
                  <textarea
                    id="crud-form-3"
                    type="text"
                    class="form-control"
                    aria-describedby="input-group-1"
                    rows="6"
                    :placeholder="$t('views.perfil_marca.text14')"
                    v-model="lang_inputs[lang_key].reviws"
                    maxlength="900"
                  />
                </div>
                <div v-if="validations.reviws" class="text-theme-6 mt-2">
                  {{ $t("views.perfil_marca.text17") }}
                </div>
              </div>

              <!-- campo de certificacion, tags -->
              <div class="mt-4">
                <label for="crud-form-3" class="form-label">{{ $t("views.perfil_marca.text15") }}</label>
                <div class="input-group">
                  <TomSelect
                    ref="certification"
                    class="w-full cursor"
                    v-model="brand.certification"
                    :max="5"
                    :placeholder="$t('views.supplements.text48')"
                    :plugins="['dropdown_input']"
                  >
                    <option value="">{{ $t("views.supplements.text48") }}</option>
                    <option v-for="(certification, key) in certificationsBrands" :key="key" :value="certification.id">
                      {{ certification.name }}
                    </option>
                  </TomSelect>
                </div>
                <div v-if="validations.certification" class="text-theme-6 mt-2">
                  {{ $t("views.supplements.text11") }}
                </div>
              </div>

              <!-- campo estado  -->
              <div class="season mt-6">
                <label for="crud-form-3" class="form-label">{{ $t("views.supplements.text94") }}</label>
                <div
                  class="mt-2 gap-4 gap-x-6 grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 xl:gap-x-6 xxl:grid-cols-6"
                >
                  <div class="form-check mr-2 mt-2 sm:mt-0">
                    <input
                      id="checkbox-switch-not-review"
                      class="form-check-input"
                      type="radio"
                      name="status"
                      v-model="brand.status"
                      value="1"
                    />
                    <label class="form-check-label" for="checkbox-switch-aspect">{{
                      $t("views.perfil_marca.UNREVIEWED")
                    }}</label>
                  </div>
                  <div class="form-check mr-2 mt-2 sm:mt-0">
                    <input
                      id="checkbox-switch-review"
                      class="form-check-input"
                      type="radio"
                      name="status"
                      v-model="brand.status"
                      value="2"
                    />
                    <label class="form-check-label" for="checkbox-switch-aspect">{{
                      $t("views.perfil_marca.REVIEWED")
                    }}</label>
                  </div>
                </div>
                <div v-if="validations.status" class="text-theme-6 mt-2">
                  {{ $t("views.supplements.text43") }}
                </div>
              </div>

              <!-- boton enviar -->
              <div class="text-right mt-5">
                <button v-on:click="saveBrand" type="button" class="btn btn-primary w-24">
                  <LoadingIcon v-if="loading" icon="three-dots" class="" />
                  <span v-else>{{ $t("views.save") }}</span>
                </button>
              </div>
            </div>
            <!-- END: Form Layout -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.dark .accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {
  --tw-text-opacity: 1;
  color: #fff;
}

.mt-3 {
  color: #fff;
}

.modal-body .recomendacion-headline {
  display: none;
}

.modal-body ul:not(ul:first-of-type) {
  margin-left: 30px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.modal-body li {
  margin-top: 10px;
  margin-bottom: 10px;
}

.max-w-label {
  max-width: 90%;
}

.text-sm-14 {
  font-size: 0.875rem;
}

.btn-source-icon {
  width: 1rem;
}

.btn-source-icon.w-6 {
  width: 1.5rem;
}

.w-50 {
  width: 50%;
}

.my-custom-input {
  display: none !important;
}

.transparent {
  color: transparent;
}

.benefits_item:last-child .remove-item {
  visibility: hidden;
}

.benefits_item:nth-child(2) {
  margin-top: 0px;
}
</style>
<script>
import Toastify from "toastify-js";
import countries from "../../../utils/countries";
import { TokenService } from "@/services/storage.service";
import BrandsService from "../../../services/brands.service";
import ApiService from "@/services/api.service";

export default {
  setup() {},
  data() {
    return {
      validations: {
        name: false,
        history: false,
        url: false,
        contacts: [],
        fundation: false,
        politic: false,
        reviws: false,
        categories: false,
        certification: false,
        countryBrand: false,
      },
      loading: false,
      recomendations: null,
      brand: {
        id: 0,
        name: "",
        history: "",
        url: "",
        fundation: "",
        politic: "",
        reviws: "",
        certification: [],
        countryBrand: "",
        status: 1,
        brand_galleries: [],
        contacts: [
          {
            id: "",
            nameCont: "",
            position: "",
            email: "",
            phone: "",
          },
        ],
      },
      activeLang: "lang__" + (localStorage.lang ? localStorage.lang : navigator.language.split("-")[0]),
      langs: this.$global.getLangs(),
      lang_key: localStorage.lang ? localStorage.lang : navigator.language.split("-")[0],
      global_lang: localStorage.lang ? localStorage.lang : navigator.language.split("-")[0],
      lang_inputs: [],
      countries: countries,
      lang_countries: [],
      certificationsBrands: [],
      gallery: [],
      galleryOptions: {
        url: "",
        acceptedFiles: "image/*",
        addRemoveLinks: true,
        paramName: "gallery",
        headers: { Authorization: `${TokenService.getToken()}` },
        maxFiles: 1,
        maxFilesize: 2,
        dictFileTooBig: this.$t("views.receipes.text34"),
        dictInvalidFileType: this.$t("views.receipes.text35"),
        dictFallbackMessage: this.$t("views.receipes.text36"),
        dictFallbackText: this.$t("views.receipes.text38"),
      },
      showGallery: true,
      getData: true,
      vueFillAprobed: false,
      status: this.$global.getAspect(),
    };
  },
  watch: {
    "$i18n.locale": function (l) {
      this.getBrand();
      this.getAllBrand();
    },
    activeLang: function () {
      this.lang_key = this.activeLang.replace("lang__", "");
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
  created() {
    this.verifiedAccess();
    var apiUri = ApiService.getApiUri();
    this.galleryOptions.url = apiUri + "/api/admin/suplement/logo-brand/upload-gallery";
    this.lang_inputs = this.langs
      .map((l) => l.key)
      .reduce((x, y) => ((x[y] = { history: "", politic: "", reviws: "" }), x), {});
    this.lang_inputs[this.lang_key].history = this.brand.history;
    this.getCertificationsBrands();
    this.getBrand();
    this.getAllBrand();
    this.countries = this.countries.sort(function (a, b) {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    this.getDataInitial();
  },
  methods: {
    /**
     * Esta función trae los datos del localStorage
     */
    getDataInitial() {
      console.log("este es mi data", this.brand);
      if (!localStorage.brandItem) return;
      const localData = JSON.parse(localStorage.brandItem);
      this.brand.id = localData.id ?? 0;
      this.brand.name = localData.name ?? "";
      this.brand.history = localData.history ?? "";
      this.brand.url = localData.url ?? "";
      this.brand.fundation = localData.fundation ?? "";
      this.brand.politic = localData.politic ?? "";
      this.brand.reviws = localData.reviws ?? "";
      this.brand.certification = localData.certification ?? [];
      this.brand.countryBrand = localData.countryBrand ?? "";
      this.brand.status = localData.status ?? 1;

      if (localData.contacts) {
        this.brand.contacts = localData.contacts;
      }

      if (localData.lang_inputs) {
        this.lang_inputs = localData.lang_inputs;
      }
    },
    verifiedAccess() {
      const permissions = localStorage.backoffice_permissions ? JSON.parse(localStorage.backoffice_permissions) : [];

      const approvedPermission = permissions.find((p) => p.name == "BRAND_ADMIN");
      if (approvedPermission) this.vueFillAprobed = true;
      else {
        this.vueFillAprobed = false;
      }
    },
    validateFundationDate() {
      const today = new Date();
      const maxDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(
        today.getDate()
      ).padStart(2, "0")}`;

      if (this.brand.fundation > maxDate) {
        // Si la fecha ingresada es mayor a hoy, corregir al máximo permitido
        this.brand.fundation = maxDate;
        this.validations.fundation = true;
      } else {
        // Resetear la validación si la fecha es válida
        this.validations.fundation = false;
      }
    },
    saveSuccessBrand() {
      Toastify({
        node: cash("#save-brand-success").clone().removeClass("hidden")[0],
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "top",
        position: "right",
        stopOnFocus: true,
      }).showToast();
    },
    async saveBrand() {
      if (!this.validate()) {
        return;
      }
      this.loading = true;

      var l_keys = Object.keys(this.lang_inputs);

      console.log("Status antes de guardar:", this.brand.status);

      this.brand.contacts = this.brand.contacts.map((contact) => ({
        id: contact.id || null,
        nameCont: contact.nameCont || "",
        position: contact.position || "",
        email: contact.email || "",
        phone: contact.phone || "",
      }));

      this.brand.certification = this.brand.certification.map((b) => parseInt(b));
      this.brand.lang_inputs = this.lang_inputs;

      // TODO: Realizar formateo cuando se termine el endpoint en el backend
      for (var i = 0; i < l_keys.length; i++) {
        this.loading = true;
        var lang = l_keys[i];

        // TODO: Guardar los items de langs inputs
        // Object.keys(this.lang_inputs[lang]).map(function (key) {
        //   this.brand[key] = this.lang_inputs[lang][key]
        // }.bind(this))

        // if (this.validations.text) {
        //   this.loading = false
        //   return
        // }

        // if (!this.brand.id) {
        //   this.brand.id = brands.length
        // }
      }

      let brands = JSON.parse(localStorage.getItem("brands")) || [];
      if (this.brand.id) {
        brands = brands.filter((b) => b.id != this.brand.id);
      } else {
        this.brand.id = brands.length + 1;
      }
      brands.push(this.brand);
      localStorage.setItem("brands", JSON.stringify(brands));

      this.loading = false;

      this.saveSuccessBrand();
      localStorage.removeItem("brandItem");
      this.$router.push({ path: "/supplement-marcas-list" });
    },
    isURLValid(url) {
      var pattern = new RegExp(
        "^(https?:\\/\\/)?" +
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
          "((\\d{1,3}\\.){3}\\d{1,3}))" +
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
          "(\\?[;&a-z\\d%_.~+=-]*)?" +
          "(\\#[-a-z\\d_]*)?$",
        "i"
      );
      return !!pattern.test(url);
    },
    isEmailValid(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    },
    validateContactFields() {
      return this.brand.contacts.every(
        (contact) => contact.nameCont && contact.position && this.isEmailValid(contact.email) && contact.phone
      );
    },
    addContact() {
      this.brand.contacts.push({ nameCont: "", position: "", email: "", phone: "" });
    },
    removeContact(index) {
      if (this.brand.contacts.length > 1) {
        this.brand.contacts.splice(index, 1);
      }
    },
    getCertificationsBrands() {
      var _this = this;
      BrandsService.getCertificationsBrands()
        .then((response) => {
          _this.certificationsBrands = response.data ? response.data : response;
          /*  var sB = _this.certificationsBrands.filter(b => {
           return _this.brand.certificationsBrands.includes(b.name)
         }) */
        })
        .catch(function (e) {
          _this.loading = false;
        });
    },
    validate() {
      const today = new Date();
      const maxDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(
        today.getDate()
      ).padStart(2, "0")}`;

      if (this.brand.fundation > maxDate) {
        this.validations.fundation = true;
        this.brand.fundation = maxDate; // Corregir automáticamente
      } else {
        this.validations.fundation = false;
      }

      this.validations.name = false;
      this.validations.history = false;
      this.validations.url = false;
      this.validations.politic = false;
      this.validations.reviws = false;
      this.validations.certification = this.brand.certification.length == 0;
      for (const l of this.langs) {
        const lang = l.key;
        if (!this.validations.history) this.validations.history = !this.lang_inputs[lang].history?.trim();
        if (!this.validations.politic) this.validations.politic = !this.lang_inputs[lang].politic?.trim();
        if (!this.validations.reviws) this.validations.reviws = !this.lang_inputs[lang].reviws?.trim();
      }

      this.validations.url = !this.isURLValid(this.brand.url);
      this.validations.contacts = !this.validateContactFields();
      this.validations.name = !this.brand.name;
      this.validations.status = !this.brand.status;

      return !Object.values(this.validations).some((val) => val === true);
    },
    changeLang(l) {
      this.activeLang = l;
    },
    getBrand: function () {
      var brand = this.brand;
      if (brand.id) {
        Object.keys(this.lang_inputs).map(
          function (lang) {
            BrandsService.getBrand(brand.id, lang).then((response) => {
              var brand = response.data ? response.data : response;
              Object.keys(this.lang_inputs[lang]).map(
                function (key) {
                  this.lang_inputs[lang][key] = brand[key];
                }.bind(this)
              );
              if (this.getData) {
                this.getData = false;
                this.brand = response.data ? response.data : response;
              }
            });
            this.showGallery = false;
            setTimeout(
              function () {
                this.showGallery = true;
              }.bind(this),
              60
            );
            if (clone) {
              delete this.brand.id;
            }
            this.brand.status = brand.status;
            this.brand.contacts = this.brand.contacts.length > 0 ? this.brand.contacts : [""];
          }.bind(this)
        );
      }
    },
    getAllBrand() {
      const brands = localStorage.getItem("brands");

      if (brands) {
        try {
          return JSON.parse(brands);
        } catch (error) {
          console.error("Error parsing brands from localStorage:", error);
          return [];
        }
      } else {
        return [];
      }
    },
    onFileAdd(data) {
      if (data && data.xhr && data.xhr.response) {
        try {
          var data = JSON.parse(data.xhr.response).data;
          if (data && data.length > 0) {
            this.brand.brand_galleries.push(data[0]);
          }
        } catch (e) {}
      }
      this.changeForm();
    },
    onFileRemove(data) {
      if (data && data.xhr && data.xhr.response) {
        try {
          var data = JSON.parse(data.xhr.response).data;
          if (data && data.length > 0) {
            data = data[0];
          }
        } catch (e) {}
      }

      var i = this.brand.brand_galleriess.findIndex((img) => img.link == data.dataURL || img.name === data.name);

      if (i !== -1 && !this.clone) {
        const photoId = this.brand.brand_galleries[i].id;
        this.brand.brand_galleries.splice(i, 1);
        BrandsService.deleteGalleryPhoto(photoId);
      }

      this.changeForm();
    },
    showMessageDropzone(file) {
      if (file.size > 2000000) {
        var message = this.$t("views.receipes.text41");
        this.$refs.alertMessage.show(message);
        var _this = this;
        setTimeout(function () {
          _this.$refs.alertMessage.hide();
        }, 3000);
      }
    },
  },
};
</script>
<style>
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  opacity: 0.2 !important;
  /* Firefox */
}
</style>
